import { fetchWrapper } from '@/_helpers';

const getExpenseQuery = ({
    provider,
    employee,
    client,
    status,
    startDate,
    endDate,
    searchText,
    page = 1,
    limit = 10,
    sortBy = null,
    team,
}) => {
    return `${team ? `&team=${team}` : ''}${provider ? `&provider=${provider}` : ''}${employee ? `&employee=${employee}` : ''}${client ? `&client=${client}` : ''}${status ? `&status=${status}` : ''}${
        startDate ? `&startDate=${startDate}` : ''
    }${endDate ? `&endDate=${endDate}` : ''}${searchText ? `&searchText=${searchText}` : ''}${sortBy ? `&sortBy=${sortBy}` : ''}&page=${page}&limit=${limit}`;
};

export async function getExpenses(options) {
    const queryParams = getExpenseQuery(options);
    return fetchWrapper.get(`/expenses?${queryParams}`);
}

export async function getExpenseById({ expenseId }) {
    return fetchWrapper.get(`expenses/${expenseId}`);
}

export async function updateExpense({ expenseId, data }) {
    return fetchWrapper.put(`expenses/${expenseId}`, data);
}

export async function approveExpense({ expenseId }) {
    return fetchWrapper.post(`/expenses/${expenseId}/approve`);
}

export async function rejectExpense({ expenseId, reason }) {
    return fetchWrapper.post(`/expenses/${expenseId}/reject`, { reason });
}
